<template>
  <LazySection>
    <section
      class="app-coming-soon-section"
      :class="{ 'app-coming-soon-section--compact': compact }"
    >
      <div
        class="container app-coming-soon-content"
        :class="{ 'app-coming-soon-content--compact': compact }"
      >
        <div
          class="app-coming-soon-visual"
          v-if="!compact"
        >
          <div class="phone-stage">
            <div class="phone-mockup">
              <span class="phone-mockup__pulse"></span>
              <div class="phone-mockup__notch"></div>
              <img
                src="@/assets/logo/logo-juf-financeiro-white.svg"
                alt="Logo Ju Financeiro"
                class="phone-mockup__logo"
              />
            </div>

            <img
              src="@/assets/icons/icone-dinheiro-min.png"
              alt=""
              class="floating-icon floating-icon--1"
            />
            <img
              src="@/assets/icons/icone-relatorio-min.png"
              alt=""
              class="floating-icon floating-icon--2"
            />
            <img
              src="@/assets/icons/icone-conta-min.png"
              alt=""
              class="floating-icon floating-icon--3"
            />
          </div>
        </div>

        <div
          class="app-coming-soon-text"
          :class="{ 'app-coming-soon-text--compact': compact }"
        >
          <span
            class="eyebrow"
            v-if="!compact"
          >
            {{ $t('message.appComingSoon.eyebrow') }}
          </span>
          <h2
            class="title"
            v-html="$t('message.appComingSoon.title')"
          />
          <p
            class="description"
            v-if="!compact"
          >
            {{ $t('message.appComingSoon.description') }}
          </p>

          <div class="platform-badges">
            <a
              :href="appStoreUrl"
              target="_blank"
              rel="noopener"
              class="platform-badge"
            >
              <i class="bi bi-apple"></i>
              iOS
              <small>{{ $t('message.appComingSoon.soon') }}</small>
            </a>
            <a
              :href="playStoreUrl"
              target="_blank"
              rel="noopener"
              class="platform-badge"
            >
              <i class="bi bi-android2"></i>
              Android
              <small>{{ $t('message.appComingSoon.soon') }}</small>
            </a>
          </div>
        </div>
      </div>
    </section>
  </LazySection>
</template>

<script>
import LazySection from './Global/LazySection.vue'
import { APP_STORE_URL, PLAY_STORE_URL } from '@/constants/appStoreLinks'

export default {
  name: 'AppComingSoonSection',
  components: {
    LazySection,
  },
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appStoreUrl: APP_STORE_URL,
      playStoreUrl: PLAY_STORE_URL,
    }
  },
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css');

.app-coming-soon-section {
  background: var(--gradient-primary-diagonal);
  padding: 5rem 0;
  overflow: hidden;
}

.app-coming-soon-section--compact {
  padding: 2.75rem 0;
}

.app-coming-soon-content {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 3rem;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 1.5rem;
  text-align: center;
}

/* Visual (phone mockup) */
.app-coming-soon-visual {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
}

.phone-stage {
  position: relative;
  width: 260px;
  margin: 0 auto;
}

.phone-mockup {
  position: relative;
  width: 190px;
  height: 380px;
  margin: 0 auto;
  border-radius: 32px;
  background: linear-gradient(
    160deg,
    rgba(255, 255, 255, 0.22),
    rgba(255, 255, 255, 0.06)
  );
  border: 2px solid rgba(255, 255, 255, 0.4);
  box-shadow: var(--box-shadow-main);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: phone-float 4s ease-in-out infinite;
}

.phone-mockup__notch {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 8px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.35);
}

.phone-mockup__logo {
  width: 55%;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.15));
}

.phone-mockup__pulse {
  position: absolute;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  animation: pulse-ring 2.4s ease-out infinite;
}

.floating-icon {
  position: absolute;
  width: 44px;
  height: 44px;
  object-fit: contain;
  padding: 8px;
  background: var(--white);
  border-radius: var(--border-radius-main);
  box-shadow: var(--box-shadow-main);
  animation: icon-float 3.6s ease-in-out infinite;
}

.floating-icon--1 {
  top: 24px;
  left: -10px;
  animation-delay: 0s;
}

.floating-icon--2 {
  top: 90px;
  right: -14px;
  animation-delay: 0.7s;
}

.floating-icon--3 {
  bottom: 40px;
  left: -18px;
  animation-delay: 1.4s;
}

@keyframes phone-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-14px);
  }
}

@keyframes icon-float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-12px) rotate(4deg);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.75);
    opacity: 0.55;
  }
  100% {
    transform: scale(1.7);
    opacity: 0;
  }
}

@media (max-width: 480px) {
  .phone-stage {
    width: 220px;
  }
  .phone-mockup {
    width: 160px;
    height: 320px;
  }
  .floating-icon {
    width: 34px;
    height: 34px;
  }
  .floating-icon--1 {
    top: 16px;
    left: -4px;
  }
  .floating-icon--2 {
    top: 76px;
    right: -4px;
  }
  .floating-icon--3 {
    bottom: 30px;
    left: -6px;
  }
}

/* Text */
.app-coming-soon-text {
  flex: 1;
}

.eyebrow {
  display: inline-block;
  padding: 0.35rem 1rem;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.2);
  color: var(--white);
  font-weight: 700;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1.25rem;
}

.app-coming-soon-text .title {
  font-family: var(--font-family-main);
  font-weight: 700;
  color: var(--white);
  font-size: clamp(1.6rem, 4vw, 2.5rem);
  line-height: 1.25;
  margin-bottom: 1rem;
}

.app-coming-soon-text .title :deep(span) {
  color: var(--white) !important;
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.5);
}

.app-coming-soon-text .description {
  color: var(--white);
  opacity: 0.9;
  font-size: clamp(1rem, 2.5vw, 1.15rem);
  line-height: 1.6;
  margin-bottom: 2rem;
}

.platform-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

.platform-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  border-radius: var(--border-radius-main);
  background: var(--white);
  color: var(--color-text-dark);
  font-weight: 700;
  font-size: 1rem;
}

.platform-badge i {
  font-size: 1.3rem;
}

.platform-badge small {
  font-weight: 600;
  color: var(--color-text-highlight);
  border-left: 1px solid var(--c6);
  padding-left: 0.5rem;
  margin-left: 0.15rem;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
}

@media (min-width: 768px) {
  .platform-badges {
    justify-content: flex-start;
  }
}

@media (min-width: 992px) {
  .app-coming-soon-content {
    flex-direction: row;
    text-align: left;
    gap: 4rem;
  }

  .app-coming-soon-text {
    text-align: left;
  }
}

/* Compact variant (reinforcement banner) */
.app-coming-soon-content--compact {
  flex-direction: column;
  gap: 1.5rem;
}

.app-coming-soon-text--compact .title {
  font-size: clamp(1.3rem, 3vw, 1.8rem);
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .app-coming-soon-text--compact {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    text-align: left;
  }

  .app-coming-soon-text--compact .platform-badges {
    flex-shrink: 0;
    justify-content: flex-end;
  }
}
</style>
